import PropTypes from 'prop-types'
import { memo } from 'react'
import clsx from 'clsx'
import useBoolean from 'src/hooks/useBoolean'
import useRouter from 'src/hooks/useRouter'
import { routersWithoutLayout, routersWithoutTopBar } from 'src/constants'
import NavBar from './NavBar'
import TopBar from './TopBar'
import useStyles from './sxStyles.sx'
import { DashboardLayoutContext } from './DashboardLayoutContext'

const DashboardLayout = ({ children }) => {
  const classes = useStyles()
  const { pathname } = useRouter()
  const { open, setToggle, setFalse } = useBoolean()

  const showWithoutLayout = routersWithoutLayout.some((val) => pathname === val)
  const showWithoutTopBar = routersWithoutTopBar.some((val) => pathname === val)

  return showWithoutLayout ? (
    children
  ) : (
    <DashboardLayoutContext.Provider value={{ onMobileNavOpen: setToggle }}>
      <div className={classes.root}>
        {!showWithoutTopBar && <TopBar onMobileNavOpen={setToggle} />}
        <NavBar onMobileClose={setFalse} isMobileNavOpen={open} />
        <div
          className={clsx(
            classes.content,
            showWithoutTopBar && classes.contentNoTopBar
          )}>
          {children}
        </div>
      </div>
    </DashboardLayoutContext.Provider>
  )
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
}

export default memo(DashboardLayout)
